import MdlProvider from '../../../../models/Purchase/PchProvider'
import MdlWarehouse from '../../../../models/Warehouse/WhWarehouse'
import MdlFamily from '../../../../models/Warehouse/WhFamily'
import MdlSubFamily from '../../../../models/Warehouse/WhSubfamily'

//
export default [
    {
        name: 'pch_provider_id',
        props: {
            chips: true,
            itemText: 'business_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: MdlProvider,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'of_warehouse',
        props: {
            chips: true,
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: MdlWarehouse,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'name',
        props: {
            label: 'Nombre',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'alias_name',
        props: {
            label: 'Alias',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'internal_code',
        props: {
            label: 'Código Interno',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'wh_family_id',
        props: {
            chips: true,
            itemText: 'family',
            itemValue: 'id',
            label: 'Familia',
            model: MdlFamily,
            noObject: true,
        },
        type: 'autocomplete-model',
    },
    {
        name: 'wh_subfamily_id',
        props: {
            chips: true,
            itemText: 'subfamily',
            itemValue: 'id',
            label: 'Sub Familia',
            model: MdlSubFamily,
            noObject: true,
            paramSearch: 'subfamily',
        },
        type: 'autocomplete-model',
    },
]
